module.exports = __webpack_public_path__ + "img/icon.8c5fbc4e.png";